/**
 * Lightweight markdown-to-HTML renderer.
 * Handles headings, bold, italic, lists, line breaks.
 * No external dependency needed.
 */
export function renderMarkdown(md: string): string {
  if (!md) return "";

  let html = md
    // Escape HTML to prevent XSS
    .replace(/&/g, "&amp;")
    .replace(/</g, "&lt;")
    .replace(/>/g, "&gt;")
    // Headings
    .replace(/^### (.+)$/gm, "<h3>$1</h3>")
    .replace(/^## (.+)$/gm, "<h2>$1</h2>")
    .replace(/^# (.+)$/gm, "<h1>$1</h1>")
    // Bold + italic
    .replace(/\*\*\*(.+?)\*\*\*/g, "<strong><em>$1</em></strong>")
    .replace(/\*\*(.+?)\*\*/g, "<strong>$1</strong>")
    .replace(/\*(.+?)\*/g, "<em>$1</em>")
    // Horizontal rule
    .replace(/^---$/gm, "<hr>")
    // Unordered lists
    .replace(/^\s*[-*] (.+)$/gm, "<li>$1</li>")
    // Ordered lists
    .replace(/^\s*\d+\. (.+)$/gm, "<li>$1</li>")
    // Inline code
    .replace(/`(.+?)`/g, "<code>$1</code>")
    // Double newlines → paragraphs
    .replace(/\n\n+/g, "</p><p>")
    // Single newlines → line breaks (not inside block elements)
    .replace(/\n/g, "<br>");

  // Wrap consecutive <li> in <ul>
  html = html.replace(/(<li>.*?<\/li>(<br>)?)+/g, (match) => {
    const items = match.replace(/<br>/g, "");
    return `<ul>${items}</ul>`;
  });

  return `<p>${html}</p>`;
}

/**
 * Fill {{placeholder}} tokens in contract body.
 */
export function fillPlaceholders(
  body: string,
  values: Record<string, string>
): string {
  return body.replace(/\{\{(\w+)\}\}/g, (_, key) => values[key] ?? `{{${key}}}`);
}
